// extracted by mini-css-extract-plugin
export var timeoutOverlay = "TimeoutOverlay-module--timeoutOverlay--1xWii";
export var timeoutFade = "TimeoutOverlay-module--timeoutFade--2oMOc";